import { render, staticRenderFns } from "./NewEditMatriculaPage.vue?vue&type=template&id=6c609852"
import script from "./NewEditMatriculaPage.vue?vue&type=script&lang=js"
export * from "./NewEditMatriculaPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports